/* Textos fijos del tema (los que no salen del editor): diccionario ES -> it, fr, pt, en */
(function () {
  var lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
  var idx = { it: 0, fr: 1, pt: 2, en: 3 }[lang];
  if (idx === undefined) return;
  var D = {
    'Total': ['Totale', 'Total', 'Total', 'Total'],
    'Pago seguro con': ['Paga in sicurezza con', 'Paiement sécurisé avec', 'Pagamento seguro com', 'Secure payment with'],
    'Saltar al contenido': ['Vai al contenuto', 'Aller au contenu', 'Saltar para o conteúdo', 'Skip to content'],
    'Esta opción no está disponible ahora mismo.': ['Questa opzione non è disponibile al momento.', "Cette option n'est pas disponible pour le moment.", 'Esta opção não está disponível neste momento.', 'This option is not available right now.'],
    'No se pudo añadir': ['Impossibile aggiungere', "Impossible d'ajouter", 'Não foi possível adicionar', 'Could not add'],
    'Abrir carrito': ['Apri il carrello', 'Ouvrir le panier', 'Abrir o carrinho', 'Open cart'],
    'Cerrar carrito': ['Chiudi il carrello', 'Fermer le panier', 'Fechar o carrinho', 'Close cart'],
    'Tu carrito': ['Il tuo carrello', 'Ton panier', 'O teu carrinho', 'Your cart'],
    'Tu carrito está vacío.': ['Il tuo carrello è vuoto.', 'Ton panier est vide.', 'O teu carrinho está vazio.', 'Your cart is empty.'],
    'Seguir comprando': ['Continua lo shopping', 'Continuer mes achats', 'Continuar a comprar', 'Continue shopping'],
    'Subtotal': ['Subtotale', 'Sous-total', 'Subtotal', 'Subtotal'],
    'Impuestos incluidos. El envío se indica antes de pagar.': ['Tasse incluse. La spedizione è indicata prima del pagamento.', 'Taxes incluses. La livraison est indiquée avant le paiement.', 'Impostos incluídos. O envio é indicado antes de pagar.', 'Taxes included. Shipping is shown before you pay.'],
    'Finalizar compra': ["Concludi l'acquisto", 'Finaliser la commande', 'Finalizar compra', 'Checkout'],
    'Menos': ['Meno', 'Moins', 'Menos', 'Less'],
    'Más': ['Più', 'Plus', 'Mais', 'More'],
    'Quitar': ['Rimuovi', 'Retirer', 'Remover', 'Remove'],
    'Foto anterior': ['Foto precedente', 'Photo précédente', 'Foto anterior', 'Previous photo'],
    'Foto siguiente': ['Foto successiva', 'Photo suivante', 'Foto seguinte', 'Next photo'],
    'Incluido con el pack doble': ['Incluso nel pack doppio', 'Inclus avec le pack double', 'Incluído no pack duplo', 'Included with the double pack'],
    '6 aromas a elegir': ['6 aromi tra cui scegliere', '6 parfums au choix', '6 aromas à escolha', '6 scents to choose from'],
    'Mejora tu pedido': ['Migliora il tuo ordine', 'Améliore ta commande', 'Melhora a tua encomenda', 'Upgrade your order'],
    'Envío prioritario': ['Spedizione prioritaria', 'Expédition prioritaire', 'Envio prioritário', 'Priority shipping'],
    'Salida con prioridad y transporte más rápido. Entrega estimada: 3-6 días laborables tras el procesado (en lugar de 6-12).': ['Partenza prioritaria e trasporto più rapido. Consegna stimata: 3-6 giorni lavorativi dopo l\'elaborazione (invece di 6-12).', 'Expédition prioritaire et transport plus rapide. Livraison estimée : 3 à 6 jours ouvrables après le traitement (au lieu de 6 à 12).', 'Saída prioritária e transporte mais rápido. Entrega estimada: 3-6 dias úteis após o processamento (em vez de 6-12).', 'Priority dispatch and faster transport. Estimated delivery: 3-6 business days after processing (instead of 6-12).'],
    'Devolución ampliada a 30 días': ['Reso esteso a 30 giorni', 'Retour prolongé à 30 jours', 'Devolução alargada a 30 dias', 'Extended 30-day returns'],
    'Tienes 30 días (en vez de 14) para devolverlo si no te convence. Tus derechos legales no cambian.': ['Hai 30 giorni (invece di 14) per restituirlo se non ti convince. I tuoi diritti legali non cambiano.', 'Tu as 30 jours (au lieu de 14) pour le retourner s\'il ne te convient pas. Tes droits légaux ne changent pas.', 'Tens 30 dias (em vez de 14) para o devolver se não gostares. Os teus direitos legais não mudam.', 'You have 30 days (instead of 14) to return it if you are not happy. Your legal rights do not change.']
  };
  var COLORS = { 'Rosa': ['Rosa', 'Rose', 'Rosa', 'Pink'], 'Blanco': ['Bianco', 'Blanc', 'Branco', 'White'] };
  var PREFIX = [
    ['Lo quiero', ['Lo voglio', 'Je le veux', 'Quero', 'I want it']],
    ['Descuentos aplicados:', ['Sconti applicati:', 'Remises appliquées :', 'Descontos aplicados:', 'Discounts applied:']],
    ['Regalo:', ['Regalo:', 'Cadeau :', 'Oferta:', 'Gift:']]
  ];
  function tr(s, inColor) {
    var t = s.trim();
    if (!t) return s;
    var r = null;
    if (inColor && COLORS[t]) r = COLORS[t][idx];
    else if (D[t]) r = D[t][idx];
    else {
      for (var i = 0; i < PREFIX.length; i++) if (t.indexOf(PREFIX[i][0]) === 0) { r = PREFIX[i][1][idx] + t.slice(PREFIX[i][0].length); break; }
    }
    return r === null || r === '' ? s : s.replace(t, r);
  }
  function node(n) {
    var v = n.nodeValue; if (!v || !v.trim()) return;
    var p = n.parentNode; if (!p || /^(SCRIPT|STYLE)$/.test(p.nodeName)) return;
    var r = tr(v, !!(p.closest && p.closest('[data-color-name]')));
    if (r !== v) n.nodeValue = r;
  }
  function attrs(el) {
    ['aria-label', 'title'].forEach(function (a) {
      var v = el.getAttribute && el.getAttribute(a);
      if (v) { var r = tr(v, !!(el.closest && el.closest('.bb-dot'))); if (r !== v) el.setAttribute(a, r); }
    });
  }
  function walk(root) {
    if (root.nodeType === 3) return node(root);
    if (root.nodeType !== 1) return;
    attrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(node);
    [].forEach.call(root.querySelectorAll('[aria-label],[title]'), attrs);
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') node(m.target);
        else [].forEach.call(m.addedNodes, walk);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();